// extracted by mini-css-extract-plugin
module.exports = {"tabActiveHoldem":"_011b6c6","tabActiveHoldemFlash":"_3a94ab4","tabActiveHoldemMax":"_29f2b09","tabActiveOmaha":"_56dee2e","logo":"_27dedc0"};